import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Table } from "antd"
import Column from "antd/lib/table/Column"
import { baseAxiosNoInfo } from "../../../tool/axios"

interface dataType {
    business_type: number // 业务类型，1预订房间 2预订换房 3办理入住 4入住换房 5办理续住 6办理出所
    business_type_desc: string // 业务类型描述
    room_code: string // 房间号
    start_date: string // 开始日期
    days: string // 天数
    opereator_user_name: string // 操作人
    opereator_time: string // 操作时间
}

export default function () {

    const param: { id: string } = useParams()
    const [data, setData] = useState<dataType[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/detail/check_operate_detail', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            res && setData(res)
        })
    }, [])

    return <div className="follow-record">
        {/* 月嫂中心 -> 会所客户管理 -> 客户详情 -> 入住记录 */}
        <Table pagination={false} scroll={{ x: 'max-content' }} style={{ width: '95%' }} dataSource={data}>
            <Column title="业务类型" dataIndex="business_type_desc" />
            <Column title="日期" dataIndex="start_date" />
            <Column title="房间号" dataIndex="room_code" />
            <Column title="天数" dataIndex="days" />
            <Column title="操作人" dataIndex="opereator_user_name" />
            <Column title="操作时间" dataIndex="opereator_time" />
        </Table>
    </div>
}